// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3_w6x","colCheckbox":"styles_colCheckbox__1Udxo"};